import { Node } from 'ts-morph'

export function getJsxAttributeName(node: Node): string | null {
  let current: Node | undefined = node

  while (current) {
    const parent = current.getParent()
    if (!parent) {
      return null
    }

    if (Node.isJsxAttribute(parent)) {
      return parent.getNameNode().getText()
    }

    if (Node.isSourceFile(parent)) {
      return null
    }

    current = parent
  }

  return null
}
